import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { LogoutConfig } from '@hdms/shared/data-access';
import { MetaNavItem, PrimaryNavItem, UserAccountData } from '@hdms/shared/page-frame/types';

@Component({
  selector: 'shrd-pf-ft-burger-menu-primary-content',
  templateUrl: './burger-menu-primary-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BurgerMenuPrimaryContentComponent {
  @Input() isAccountMenu: boolean;
  @Input() userData: UserAccountData;
  @Input() metaNavItems: MetaNavItem[];
  @Input() logoutConfig: LogoutConfig;
  @Input() primaryNavItems: PrimaryNavItem[];
  @Output() menuSelected = new EventEmitter<PrimaryNavItem | MetaNavItem>();

  onMenuSelect(selectedItem: PrimaryNavItem | MetaNavItem): void {
    this.menuSelected.emit(selectedItem);
  }
}
